import styled from 'styled-components';

export const StyledAssetModal = styled.div`
  width: ${({ theme }) => theme.assetModalWidth};

  .asset-modal-info-holder {
    border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
  }

  .asset-modal-info-decorator {
    border-right: solid 2px ${({ theme }) => theme.borderDark};
    border-left: solid 2px ${({ theme }) => theme.borderDark};
    width: calc(${({ theme }) => theme.assetModalWidth} / 2 - 24px) ;
    background: ${({ theme }) => theme.selection};
    height: ${({ theme }) => theme.frameWidth};
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: 20px;
    margin-right: 20px;
  }

  .asset-modal-consume-button-holder {
    padding: 1rem;
    padding-top: 0;
  }

  .asset-modal-consume-button-content {
    width: 100%;
    height:100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    img {
      height: 100%;
    }
  }

  .asset-modal-title-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    height: 26px;
    gap: 2px;
  }

  .asset-modal-title-stub-short {
    background: ${({ theme }) => theme.menuTitle};
    width: 20px;
    min-width: 20px;
    height: 100%;
  }

  .asset-modal-title-stub-long {
    background: ${({ theme }) => theme.menuTitle};
    width: 100%;
    height: 100%;
  }

  .asset-modal-title {
    text-transform: uppercase;
    height: 100%;
    padding: 0 6px;
    font-family: "BebasNeue";
    font-size: 2em;
    font-weight: 500;
    color: white;
    line-height: 1;
    white-space: nowrap;
  }

  .asset-modal-preview-content {
    width: 100%;
    height: ${({ theme }) => theme.assetModalPreviewHeight};
    position: relative;
    background: ${({ theme }) => theme.brightBlue};
  }

  .asset-modal-preview-content-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .asset-modal-preview-image-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .asset-modal-preview-image {
    max-width: 100%;
    height: 100%;
  }

  .asset-modal-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    width: 100%;
  }

  .asset-modal-info-description {
    width: 50%;
    padding: 12px 20px 0 20px;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-weight: 400;
    font-size: 1.25rem;
  }

  .asset-modal-info-traits {
    width: 50%;
  }
  
  .asset-modal-title-button {
    height: 30px;
    padding: ${({ theme }) => theme.buttonFrameWidth};
    white-space: nowrap;
    position: relative;

    .asset-modal-title-button-corner {
      position: absolute;
      border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'transparent'};
      top: 0;
      bottom: 0;
      width: 8px
    }

    .asset-modal-title-button-corner-l {
      border-right: none;
      left: 0;
    }

    .asset-modal-title-button-corner-r {
      border-left: none;
      right: 0;
    }

    &:hover {
      .asset-modal-title-button-corner {
        border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
      }

      .asset-modal-title-button-corner-l {
        border-right: none;
      }

      .asset-modal-title-button-corner-r {
        border-left: none;
      }
    }
  }

  .asset-modal-title-button-content {
    width: 100%;
    height: 100%;
    padding: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    align-items: center;
    transition: background linear 0.2s;
  }

  .asset-modal-title-button-label {
    font-family: 'BebasNeue';
    font-size: 1.25rem;
    font-weight: 700;
    color: black;
    padding-top: 4px;
  }
`;
